import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
const FLYOUT_ASIDE_ELEMENT_WIDTH = 296;
const FLYOUT_ASIDE_ELEMENT_WIDTH_XL = 360;
export const navigationFlyoutAsideElementStyles = () => css `
	display: flex;
	flex-direction: column;
	aspect-ratio: 4 / 3;
	width: ${FLYOUT_ASIDE_ELEMENT_WIDTH}px;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xl)}) {
		width: ${FLYOUT_ASIDE_ELEMENT_WIDTH_XL}px;
	}
`;
export const NavigationFlyoutAsideElement = styled.div `
	${navigationFlyoutAsideElementStyles}
`;
